import { createSelector } from 'reselect';
import { hideAutoReplenishSelector } from 'selectors/testTarget/offers/hideAutoReplenish/hideAutoReplenishSelector';

const activeSelector = createSelector(hideAutoReplenishSelector, hideAutoReplenish => !!hideAutoReplenish.active);

export { activeSelector };
